import React from 'react';
import ReactDOM from 'react-dom/client';
import "./components/dasboardv3/styles/custom-bootstrap.scss";
import AppRouter from './components/AppRouter';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { AuthProvider, MockAuthProvider } from './contexts/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import config from './config';

const cognitoAuthConfig = {
  authority: config.auth.cognito.authority,
  client_id: config.auth.cognito.client_id,
  redirect_uri: config.auth.cognito.redirect_uri,
  post_logout_redirect_uri: config.auth.cognito.post_logout_redirect_uri,
  response_type: config.auth.cognito.response_type,
  scope: config.auth.cognito.scope,
  automaticSilentRenew: true,
  loadUserInfo: false,
  // Explicitly configure to use localStorage for token persistence
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: (_user) => {
    // Only clean up URL if we have OIDC callback params (code, state)
    const url = new URL(window.location.href);
    if (url.searchParams.has('code') || url.searchParams.has('state')) {
      // Remove OIDC params from URL after login, preserving hash-based routing
      const newUrl = window.location.origin + window.location.pathname + (window.location.hash || '');
      window.history.replaceState({}, document.title, newUrl);
    }
  },
};

// Mock auth for offline UI development against the HAR mock server.
// Only honored in development builds so the flag can never disable auth in production.
const useMockAuth = process.env.NODE_ENV === 'development' && process.env.REACT_APP_AUTH_MOCK === '1';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {useMockAuth ? (
      <MockAuthProvider>
        <AppRouter />
      </MockAuthProvider>
    ) : (
      <OidcAuthProvider {...cognitoAuthConfig}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </OidcAuthProvider>
    )}
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
